// @flow
import FlagsContainer from './FlagsContainer';

export default FlagsContainer;
